import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import B2BLEADAPI from "../../Api/b2bLead";
import { setMessage } from "./message";
import EventBus from "../../utils/EventBus";


// Create B2B Lead
export const createB2bLead = createAsyncThunk('b2bLead/createB2bLead', async (formData, thunkAPI) => {
    try {
        const response = await B2BLEADAPI.createB2bLead(formData);
        const message=(response.message)

        thunkAPI.dispatch(setMessage(message))
        return response.data;
    }catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message)
    }
})

// Get B2B Lead
export const getB2bLead = createAsyncThunk('b2bLead/getB2bLead', async (params, thunkAPI) => {
    try {
        const response = await B2BLEADAPI.getB2bLead(params);
        const message=(response.message)

        thunkAPI.dispatch(setMessage(message))
        return response.data;
    }catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message)
    }
})

// Get B2B Lead By Id
export const getB2bLeadById = createAsyncThunk('b2bLead/getB2bLeadById', async ({l_id}, thunkAPI) => {
    try {
        const response = await B2BLEADAPI.getB2bLeadById(l_id);
        return response.data;
    }catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message)
    }
})

// Update B2B Lead
export const updateB2bLead = createAsyncThunk('b2bLead/updateB2bLead', async ({l_id, formData}, thunkAPI) => {
    try {
        const response = await B2BLEADAPI.updateB2bLead(l_id, formData);
        return response.data;
    }catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message)
    }
})

// PYTON API

// Create B2B Lead Template
export const createB2bLeadPython = createAsyncThunk('b2bLead/createB2bLeadPython', async (formData, thunkAPI) => {
  try {
      const response = await B2BLEADAPI.createB2bLeadPython(formData);
      const message=(response.message)

      thunkAPI.dispatch(setMessage(message))
      return response.data;
  }catch (error) {
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        EventBus.dispatch("logout");
      }
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message)
  }
})

const b2bLeadSlice = createSlice({
    name: 'b2bLead',
    initialState: {
        b2bLeads : [],
        b2bLeadDetail : null,
        totalPages: "",
        totalCount: 0
    },
     extraReducers: (builder) => {
        builder
          .addCase(getB2bLead.fulfilled, (state, action) => {
            state.b2bLeads = action.payload.data
            state.totalPages = action.payload.totalPages
            state.totalCount = action.payload.totalCount
          })
          .addCase(createB2bLead.fulfilled, (state, action) => {
            state.b2bLeads.push(action.payload.data)
          })

          .addCase(createB2bLeadPython.fulfilled, (state, action) => {
            console.log("createB2bLeadPython:",action.payload.response);
            state.b2bLeads = action.payload
          })
          .addCase(updateB2bLead.fulfilled, (state, action) => {
                  const {arg: { c_id }} = action.meta;
                  if (c_id) {
                    state.b2bLeads = state.b2bLeads.map((item) =>
                      item._id === c_id ? action.payload.data : item
                    );
                  };
            })
          .addCase(getB2bLeadById.fulfilled, (state, action) => {
            state.b2bLeads = action.payload.data
          })
        }
})

const { reducer } = b2bLeadSlice;
export default reducer;